"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determine whether the given value is a function.
 *
 * @Param {any} func - The supposed function.
 *
 * @Example
 *
 *   isFunction(() => null)
 *   //=> true
 *
 *   isFunction(null)
 *   //=> false
 */
function isFunction(func) {
    return typeof func === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=is-function.js.map